import React from 'react';
import styles from './Footer.module.scss';

type Footer = {
  version: string;
};

const Footer: React.SFC<Footer> = ({ version }) => {
  const year = new Date().getFullYear();
  return (
    <div className={styles.footer}>
      <div className='row'>
        <div className='col-6'>
          <p className={styles.version}>
            Version: {version}
            <button id='focus-dummy' style={{ opacity: 0, width: 0 }}></button>
          </p>
        </div>
        <div className='col-6'>
          <p className={styles.copyrightLabel}>Powered by Siemens Gamesa Renewable Energy A/S &copy; Copyright {year}</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
